import { useMemo } from 'react';

export function useGameNavigation(gameId, games) {
  const prevId = useMemo(() => games && findPrevGame(games, gameId), [
    games,
    gameId,
  ]);
  const nextId = useMemo(() => games && findNextGame(games, gameId), [
    games,
    gameId,
  ]);
  const thisId = gameId;

  return { prevId, nextId, thisId };
}

function findNextGame(games, gameId) {
  const index = findIndexGame(games, gameId);
  const prevGameIndex = index === 0 ? null : index - 1;

  return prevGameIndex !== null ? games[prevGameIndex] : null;
}

function findPrevGame(games, gameId) {
  const index = findIndexGame(games, gameId);
  const nextGameIndex = index + 1 === games.length ? null : index + 1;

  return nextGameIndex !== null ? games[nextGameIndex] : null;
}

function findIndexGame(games, gameId) {
  return games.findIndex(game => game.id === gameId);
}
